import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap, shareReplay, finalize, catchError, throwError, switchMap } from 'rxjs';
import { TokenResponse } from 'src/app/domain/models/TokenResponse';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { Router } from '@angular/router';
import { SecurityGateway } from 'src/app/application/gateway/SecurityGateway';
import { Routes } from '../routes';
import { environment } from 'src/environments/environment';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private authService: AuthGateway,
      private router: Router,
      private securityService: SecurityGateway

  ) {}

  /**
   * Observable compartido mientras el refresh está ejecutándose.
   */
  private refreshRequest$?: Observable<TokenResponse>;
  public intercept(
    request: HttpRequest<any>,
    newRequest: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if(request.url.startsWith('/')) {
      if(!request.url.startsWith('/assets/i18n/')) {

        var accessToken = this.authService.getToken();
        request = this.addTokenAndUrl(request, accessToken);
      }
    }
    return newRequest.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // En caso de token expirado, hacemos refresh y reintentamos la petición original.
        if (error.status === 401 && this.isTokenExpired(error)) {
          return this.refresh().pipe(
            switchMap((tokens) => {
              const newRequestWithToken = this.addToken(request, tokens.data.accessToken);
              return newRequest.handle(newRequestWithToken);
            })
          );
        } else {
          this.redirectInError(error);
          return throwError(() => error);
        }
      })
    );
  }

    private addTokenAndUrl(
      request: HttpRequest<any>,
      token: string
  ): HttpRequest<any> {

      return request.clone({
          url: environment.apiUrl + request.url,
          setHeaders: {

              Authorization: `Bearer ${token}`

          }

      });

  }

  private addToken(
    request: HttpRequest<any>,
    token: string
  ): HttpRequest<any> {
      return request.clone({
          setHeaders: {

              Authorization: `Bearer ${token}`

          }

      });
  }

    /**
   * Aquí depende de cómo responda tu backend.
   */
    private isTokenExpired(error: HttpErrorResponse): boolean {

        return error.error?.code === 'expired_token';

    }

  /**
   * Solo crea UN refresh.
   * Todas las peticiones reutilizan el mismo Observable.
   */
    private refresh(): Observable<TokenResponse> {

        if (!this.refreshRequest$) {

            this.refreshRequest$ = this.securityService.doRefreshToken(
                this.authService.getToken(), this.authService.getRefreshToken()).pipe(
                tap((response: TokenResponse) => {
                    this.authService.authenticate(response.data.accessToken, response.data.refreshToken);
                }),
                shareReplay(1),

                finalize(() => {
                    this.refreshRequest$ = undefined;
                }),

                catchError(error => {
                    this.redirectInError(error);
                    return throwError(() => error);

                })
            );

        }
        return this.refreshRequest$;

    }

    redirectInError(error: HttpErrorResponse): void {
      if (error.status === 401) {
          this.authService.logout();
          this.router.navigate([Routes.login]).then()
        } else if (error.status === 403) {
          this.router.navigate([Routes.forbiddenPage]).then()
        }
    }
}
